import { Row, Col, Button, Icon } from 'antd';
import { ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { fsdoRegConfig } from '../../forms/registration/formConfig';

const { IconPopover } = ssCommonUtils,
config = fsdoRegConfig,
{ key } = config,
{ validateForm, validateSubForm } = ssFormValidationUtils,
EMAIL_FIELD = 'emailAddress',
VERIFY_EMAIL = 'verifyEmail',
VERIFY_EMAIL_MESSAGE = 'Email addresses must match',
FIRSTNAME_FIELD = 'firstName',
LASTNAME_FIELD = 'lastName',
VERIFY_VALID_NAME_MESSAGE = 'If you have one name, you must provide a first or last name';;

export default class FsdoSubmit extends React.Component {
    constructor(props) { 
        super(props);
    }

    canSubmit() {
        const
        { fsdo, services, registrationForm } = this.props,
        { status } = fsdo.fsdoInfo,
        currForm = registrationForm[key],
        { contact } = fsdo;

        if (currForm) {
            if (contact.existingEmail) {
                if (contact.existingEmail === currForm.emailAddress) {
                    return false;
                }
            } 
            if(currForm[EMAIL_FIELD] !== currForm[VERIFY_EMAIL]) {
                return false;
            }

            if(currForm[FIRSTNAME_FIELD] && currForm[LASTNAME_FIELD]) {
                if(currForm[FIRSTNAME_FIELD].trim() === '-' && currForm[LASTNAME_FIELD].trim() === '-') {
                    return false;
                }
            }

            const formState = validateForm(registrationForm[key], config, true);
            return validateSubForm(formState);
        }

        return false;
    }

    componentDidMount() {
        const
        { fsdo, registrationForm, services } = this.props;

        if (fsdo.contact.errorCode === 409) {
            services.fsdoSetExistingEmail(registrationForm[key].emailAddress);
            this.setVerificationError(true, EMAIL_FIELD, fsdo.contact.help, "error");
        }
    }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm, fsdo } = this.props,
        { contact } = fsdo,
        currForm = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm, storeFormField } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, currForm)) {
            const formState = validateForm(currForm, config, true);
            storeForm(key, formState);
            this.setState({ isValid: this.verifyEmail(this.props, true) 
                && this.verifyAtLeastOneValidName(this.props, true) && validateSubForm(formState) });

            if (contact.existingEmail) {
                if (contact.existingEmail === currForm.emailAddress) {
                    this.setVerificationError(true, EMAIL_FIELD, contact.help, "error");
                }
            }
        }
    }

    verifyEmail(nextProps, updateState) {
        const
        { registrationForm, fsdo } = nextProps,
        form = registrationForm[key];

        if(form[VERIFY_EMAIL] || form[EMAIL_FIELD]) {
            if(form[VERIFY_EMAIL] === form[EMAIL_FIELD]) {
                if(updateState) this.setVerificationError(false, VERIFY_EMAIL, VERIFY_EMAIL_MESSAGE, 'success');
                return true;
            }
            if(updateState) this.setVerificationError(true, VERIFY_EMAIL, VERIFY_EMAIL_MESSAGE, 'error');
            return false;
        } else return true;
    }

    setVerificationError(inError, field, errorMessage, status) {
        const
        { storeFormField } = this.props.services;
        storeFormField(key, `${field}_help`, inError ? errorMessage : '');
        storeFormField(key, `${field}_status`, status);
    }

    verifyAtLeastOneValidName(nextProps, updateState) {
        const
        { registrationForm } = nextProps,
        form = registrationForm[key],
        firstName = form[FIRSTNAME_FIELD],
        lastName = form[LASTNAME_FIELD];
        if(firstName || lastName) {
            if(firstName.trim() === '-') {
                if(lastName.trim() === '-') {
                    if(updateState) this.setOneValidNameError(true);
                    return false;
                }
            }
            return true;
        } else return true;
    }

    setOneValidNameError(inError, field) {
        const
        { storeFormField } = this.props.services;
        storeFormField(key, `${LASTNAME_FIELD}_help`, inError ? VERIFY_VALID_NAME_MESSAGE : '');
        storeFormField(key, `${LASTNAME_FIELD}_status`, inError ? 'error' : 'success');
        storeFormField(key, `${FIRSTNAME_FIELD}_help`, inError ? VERIFY_VALID_NAME_MESSAGE : '');
        storeFormField(key, `${FIRSTNAME_FIELD}_status`, inError ? 'error' : 'success');
    }

    render() {
        const
        { services, text } = this.props,
        { textDataStore } = text;

        let fsdoEmail, fsdoPhone;
        if(textDataStore['CINFO']){
            fsdoEmail = (
                <span style={{ fontWeight: 'bold' }}>
                    {textDataStore['CINFO'].p[0].text}
                </span>
            );
            fsdoPhone = (
                <span style={{ fontWeight: 'bold' }}>
                    {textDataStore['CINFO'].p[1].text}
                </span>
            );
        }

        return (
            <div style={{ position: 'fixed', zIndex:1, textAlign: 'center', top: '78%', width: '100%' }}>
                <Row type='flex' justify='center' gutter={12}>
                    <Col span={10}>
                        <p>{"As an FAA Flight Standards employee you will be reviewing information provided to TSA by an individual or company who is registered with the FAA to provide flight training. Information on the review process is contained in the Flight Standards Information Management System 8900.1, Volume 8, Chapter 8."}</p>
                        <p>{"You can review the Flight Training Security Program processes by accessing the Application Guide and Frequently Asked Questions which is available online under the Help menu after you log in to the system."}</p>
                    </Col>
                </Row>
                <Row type='flex' justify='center' style={{ marginTop: '-14px' }} gutter={12}>
                    <Col span={5}>
                        <Button
                            size='small'
                            type='primary'
                            icon='check-circle-o'
                            style={{ width: '100%', marginTop: '24px' }}
                            disabled={!this.canSubmit()}
                            onClick={() => services.fsdoToggleSubmitView()}
                        >
                            {'Submit'}
                        </Button>
                    </Col>
                </Row>
                <Row type='flex' justify='center'>
                    <Col>
                        {fsdoEmail == null || fsdoPhone == null ? null : (
                            <IconPopover 
                                title='Help' 
                                header='Need help?' 
                                placement='top'
                                style={{
                                    position: 'absolute',
                                    width: '100%',
                                    left: '-8.5%',
                                    top: '25px'
                                }}
                            >
                                <div>
                                    {'Please Contact the FTSP Help Desk at '}
                                    {fsdoEmail}{' or '}{fsdoPhone}{'.'}
                                </div>
                            </IconPopover>
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}
